/* Consent is registered only after an explicit visitor choice. */
(function () {
  'use strict';
  var banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;
  // Shopify consent cannot be registered for a loopback development origin.
  // Preview choices use a separate key and never grant Shopify tracking consent.
  var localPreview = ['localhost', '127.0.0.1', '[::1]'].indexOf(location.hostname) !== -1;
  var key = localPreview ? 'avant_cookie_preview_choice' : 'avant_cookie_consent';
  var lifetime = 180 * 24 * 60 * 60 * 1000;
  var status = banner.querySelector('[data-cookie-status]');
  var buttons = banner.querySelectorAll('[data-cookie-choice]');
  var returnFocus;
  var busy = false;
  var loading;
  var previewNote = banner.querySelector('[data-cookie-preview-note]');
  if (previewNote) previewNote.hidden = !localPreview;

  function read() {
    var raw;
    try { raw = document.cookie.split('; ').find(function (c) { return c.indexOf(key + '=') === 0; }); } catch (_) {}
    try {
      raw = raw ? decodeURIComponent(raw.slice(key.length + 1)) : localStorage.getItem(key);
      var saved = JSON.parse(raw);
      return saved && saved.version === 1 && typeof saved.accepted === 'boolean' && saved.expires > Date.now() ? saved : null;
    } catch (_) { return null; }
  }

  function remember(accepted) {
    var raw = JSON.stringify({ version: 1, accepted: accepted, expires: Date.now() + lifetime });
    try { localStorage.setItem(key, raw); } catch (_) {}
    try { document.cookie = key + '=' + encodeURIComponent(raw) + '; Path=/; Max-Age=' + lifetime / 1000 + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (_) {}
  }

  function privacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var started = Date.now();
      function attempt() {
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          var timer = setTimeout(function () { reject(new Error('Consent service timed out')); }, 8000);
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
              clearTimeout(timer);
              if (error || !window.Shopify.customerPrivacy) reject(error || new Error('Consent unavailable'));
              else resolve(window.Shopify.customerPrivacy);
            });
          } catch (error) { clearTimeout(timer); reject(error); }
        } else if (Date.now() - started < 8000) setTimeout(attempt, 200);
        else reject(new Error('Consent unavailable'));
      }
      attempt();
    }).catch(function (error) { loading = null; throw error; });
    return loading;
  }

  function show(focus) {
    banner.hidden = false;
    if (focus) banner.querySelector('h2').focus();
  }

  document.querySelectorAll('[data-cookie-open]').forEach(function (button) {
    button.hidden = false;
    button.addEventListener('click', function () { returnFocus = button; show(true); });
  });

  buttons.forEach(function (button) {
    button.addEventListener('click', async function () {
      if (busy) return;
      busy = true;
      buttons.forEach(function (item) { item.disabled = true; });
      status.textContent = 'Saving your choice…';
      var accepted = button.dataset.cookieChoice === 'accept';
      try {
        if (!localPreview) {
          var api = await privacy();
          await new Promise(function (resolve, reject) {
            var timer = setTimeout(function () { reject(new Error('Save timed out')); }, 8000);
            api.setTrackingConsent({ analytics: accepted, marketing: accepted, preferences: accepted }, function (result) {
              clearTimeout(timer);
              if (result && result.error) reject(new Error('Save failed'));
              else resolve();
            });
          });
        }
        remember(accepted);
        banner.hidden = true;
        status.textContent = '';
        if (returnFocus) returnFocus.focus();
        else {
          var footerControl = document.querySelector('[data-cookie-open]');
          if (footerControl) footerControl.focus({ preventScroll: true });
        }
      } catch (_) {
        status.textContent = 'We couldn’t save your choice. Please check your connection and try again.';
      } finally {
        busy = false;
        buttons.forEach(function (item) { item.disabled = false; });
      }
    });
  });

  // Read Shopify's existing consent too, including choices made with another banner.
  var saved = read();
  if (localPreview) {
    if (!saved) show(false);
  } else {
    privacy().then(function (api) {
      if (busy || !banner.hidden) return;
      var consent = api.currentVisitorConsent();
      var complete = ['analytics', 'marketing', 'preferences'].every(function (purpose) { return consent[purpose] === 'yes' || consent[purpose] === 'no'; });
      // A local dismissal must not hide a missing or expired Shopify consent record.
      if (!complete) show(false);
    }).catch(function () { if (!saved) show(false); });
  }

  window.addEventListener('storage', function (event) {
    if (event.key === key && read() && !busy) banner.hidden = true;
  });
})();
